// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IStyle } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import {
  getHighContrastNoAdjustStyle,
  HighContrastSelector,
  memoizeFunction,
} from "@fluentui/react";

export type InnerBorderSettings = {
  /** width of the inner border */
  width: number | string;

  /** Color of the inner border */
  color: string;

  /** Gap between outer and inner border (or number of pixels inside outer edge if no outer border present) */
  gap?:
    | number
    | string
    | {
        top: string | number;
        bottom: string | number;
        right: string | number;
        left: string | number;
      };

  /** Border style */
  style?:
    | "solid"
    | "dashed"
    | "dotted"
    | "double"
    | "groove"
    | "ridge"
    | "inset"
    | "outset"
    | "hidden"
    | "none";

  radius?: string;
};

/** Inner border is most easily achieved with :after CSS selector. The selector itself is defined by the caller and this
 * function just returns the styles (IStyle) necessary
 */
export const getInnerBorderStyles: (
  borderSettings: InnerBorderSettings
) => IStyle = memoizeFunction((borderSettings: InnerBorderSettings) => {
  const gap = borderSettings.gap;
  const gapStyles =
    typeof gap === "object"
      ? gap
      : {
          top: gap || 0,
          bottom: gap || 0,
          left: gap || 0,
          right: gap || 0,
        };
  const borderRadiusStyles = borderSettings.radius
    ? { borderRadius: borderSettings.radius }
    : undefined;

  return {
    content: '""',
    position: "absolute",
    borderWidth: borderSettings.width,
    borderStyle: borderSettings.style || "solid",
    borderColor: borderSettings.color,
    pointerEvents: "none",
    ...gapStyles,
    ...borderRadiusStyles,
    selectors: {
      [HighContrastSelector]: {
        borderColor: "HighlightText",
        ...getHighContrastNoAdjustStyle(),
      },
    },
  };
});
